import { initialConfig } from '@/utils/initialConfig'

const state = {
  config: initialConfig(),
  // Keys in 'excludeConfigs' will not be rendered as an option in the config page
  attributes: '',
  userAttributes: '',
  excludeConfigs: [
    'zebraffeLoader',
    'gaTag',
    'isMobile',
    'scrollToOffset',
    'scrollToPm',
    'feeAmount',
    'allowUserToDisableCancelWithdrawals',
    'additionalCashierText',
    'preventCancelWithdrawal',
    'trackingPixels',
    'fetchConfig'
  ],
  cashierVersion: null,
  bootstrapVersion: null,
  countries: [
    {
      country: 'Sweden',
      userId: 'PayTestSE'
    },
    {
      country: 'Finland',
      userId: 'PayTestFI'
    },
    {
      country: 'Norway',
      userId: 'PayTestNO'
    },
    {
      country: 'UK',
      userId: 'PayTestGB'
    },
    {
      country: 'US',
      userId: 'PayTestUS'
    },
    {
      country: 'Germany',
      userId: 'PayTestDE'
    },
    {
      country: 'Denmark',
      userId: 'PayTestDK'
    }
  ]
}

export default state
